import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/content";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((v) => (v + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (dir: number) => setIndex((v) => (v + dir + total) % total);
  const slide = heroSlides[index];

  return (
    <section className="relative h-[420px] w-full overflow-hidden rounded-lg bg-primary-900 md:h-[520px]">
      {heroSlides.map((item, i) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={item.image}
            alt={item.title}
            title={item.title}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/80 via-primary-950/50 to-primary-950/20"></div>
        </div>
      ))}

      <div className="relative flex h-full flex-col justify-end p-6 md:p-12">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-white">
            <i className="ri-fire-line"></i>
            {slide.kicker}
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-tight text-white md:text-4xl">
            {slide.title}
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/85 md:text-base">{slide.desc}</p>
          <Link
            to={slide.link}
            className="mt-6 inline-flex cursor-pointer items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-white transition-colors hover:bg-accent-600"
          >
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/40 text-white backdrop-blur transition-colors hover:bg-primary-950/70 md:left-6 md:h-10 md:w-10"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/40 text-white backdrop-blur transition-colors hover:bg-primary-950/70 md:right-6 md:h-10 md:w-10"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 right-6 hidden items-center gap-2 md:flex">
        {heroSlides.map((item, i) => (
          <button
            key={item.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setIndex(i)}
            className={`h-1.5 cursor-pointer rounded-full transition-all ${
              i === index ? "w-6 bg-accent-500" : "w-1.5 bg-white/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}